<template>
  <div>
    <ejs-treeview v-if='refresh' id='moTreeCheck' ref='moTreeCheck'  :fields='checkTreeData'  :showCheckBox='true'>
    </ejs-treeview>
  </div>
</template>

<script>
export default {
  name: 'MoTreeCheck',
  data() {
    return {
      checkTreeData:JSON.parse(sessionStorage.getItem("mmlTreeData")),
      checkNodes :[],
      refresh : true
    };
  },
  created() {
  },
  methods: {
    reload: function() {
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
    getCheckNodes : function(){
      console.log("getCheckNodes",this.$refs.moTreeCheck.getAllCheckedNodes())
      return this.$refs.moTreeCheck.getAllCheckedNodes();
    }
  }
};
</script>
<style>
</style>
